import { hasAnyRole } from '@/utils/permissions'
import store from '@/store'

export default {
  mounted() {
    // Check if this is a router-link component by checking the props and element tag
    if (this.$props && this.$props.to && this.$el && this.$el.tagName === 'A') {
      this.$nextTick(() => {
        this.checkRoutePermission()
      })
    }
  },

  updated() {
    // Recheck permissions on component update
    if (this.$props && this.$props.to && this.$el && this.$el.tagName === 'A') {
      this.$nextTick(() => {
        this.checkRoutePermission()
      })
    }
  },

  methods: {
    checkRoutePermission() {
      try {
        const router = this.$router
        if (!router || !this.$props.to) {
          return
        }

        const resolvedRoute = router.resolve(this.$props.to)
        const routeMeta = resolvedRoute.meta || (resolvedRoute.matched && resolvedRoute.matched.length > 0 && resolvedRoute.matched[0].meta)

        const user = store.getters['auth/currentUser']

        // Super admin can access everything
        if (user && user.is_superadmin) {
          this.showElement()
          return
        }

        // If route requires auth and user is not logged in, remove link
        if (routeMeta && routeMeta.requiresAuth && !user) {
          this.removeElement()
          return
        }

        // If route specifies roles, check if user has required roles
        if (routeMeta && routeMeta.roles && routeMeta.roles.length > 0) {
          if (hasAnyRole(routeMeta.roles)) {
            this.showElement()
          } else {
            this.removeElement()
          }
          return
        }

        // If route is public or doesn't require auth, always show it
        if (routeMeta && (routeMeta.public === true || routeMeta.requiresAuth === false)) {
          this.showElement()
          return
        }

        // If no roles specified and not a public route, remove the link
        this.removeElement()

      } catch (error) {
        console.warn('Error checking route permissions:', error)
        // On error, remove the link to be safe
        this.removeElement()
      }
    },

    removeElement() {
      if (this.$el && this.$el.parentNode) {
        // Store the parent element to remove the entire wrapper if needed
        const parentElement = this.$el.parentNode

        // If the parent is a wrapper div (like column div), remove the entire parent
        if (parentElement.classList.contains('column') || 
            parentElement.classList.contains('card') ||
            parentElement.classList.contains('module-card-link')) {
          parentElement.remove()
        } else {
          // Otherwise just remove the link element
          this.$el.remove()
        }
      }
    },

    showElement() {
      // Element is already shown by default, no action needed
      return
    }
  }
}
